export default "__VITE_ASSET__f1kd$gLN__"